/**
 * Cheeky Frog — minimum order value
 *
 * Disables checkout below the floor and says how much more is needed. See
 * snippets/cf-cart-minimum.liquid for why this is a courtesy rather than a
 * control, and what actually enforces the floor.
 *
 * The cart total is read from /cart.js rather than scraped off the page: the
 * rendered total carries a currency symbol and grouping, and parsing money out
 * of text is how you end up charging someone 1 rupee instead of 1,000.
 */
(function () {
  'use strict';

  var cfg = document.querySelector('[data-cf-cart-minimum]');
  if (!cfg) return;

  var MIN = parseInt(cfg.dataset.cfCartMinimum, 10);
  var LABEL = cfg.dataset.cfCartMinimumLabel || '';
  if (!Number.isFinite(MIN) || MIN <= 0) return;

  var NOTE = 'cf-cart-min__note';

  function money(paise) {
    try {
      return new Intl.NumberFormat('en-IN', {
        style: 'currency', currency: 'INR', maximumFractionDigits: 0,
      }).format(paise / 100);
    } catch (e) {
      return '₹' + Math.ceil(paise / 100);
    }
  }

  function buttons() {
    return Array.prototype.slice.call(
      document.querySelectorAll('[name="checkout"]'));
  }

  function apply(total) {
    var short = MIN - total;
    var blocked = total > 0 && short > 0;

    buttons().forEach(function (btn) {
      // Remember the cart's own reason for disabling it (an empty cart, a
      // sold-out line) so this never re-enables a button Shopify disabled.
      if (btn.disabled && !btn.dataset.cfMinDisabled) return;
      btn.disabled = blocked;
      btn.dataset.cfMinDisabled = blocked ? '1' : '';
      if (!blocked) delete btn.dataset.cfMinDisabled;

      var note = btn.parentNode.querySelector('.' + NOTE);
      if (blocked) {
        if (!note) {
          note = document.createElement('p');
          note.className = NOTE;
          note.setAttribute('role', 'status');
          btn.parentNode.insertBefore(note, btn);
        }
        note.textContent = 'Minimum order ' + LABEL + '. Add ' +
          money(short) + ' more to check out.';
      } else if (note) {
        note.remove();
      }
    });
  }

  var pending = null;
  function refresh() {
    clearTimeout(pending);
    pending = setTimeout(function () {
      fetch(window.Shopify && window.Shopify.routes
        ? window.Shopify.routes.root + 'cart.js' : '/cart.js',
        { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { apply(cart.total_price); })
        .catch(function () { /* leave the button alone if we cannot tell */ });
    }, 120);
  }

  refresh();

  // Dawn re-renders the cart by replacing whole sections, so the button this
  // ran against is thrown away and rebuilt. Watch for that rather than trying
  // to hook every quantity control.
  var mo = new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      if (records[i].addedNodes.length) { refresh(); return; }
    }
  });
  mo.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('cart:refresh', refresh);
})();
